// This method currenctly only support floor rounding behavior
export function roundToDecimal(value, decimal) {
  const factor = Math.pow(10, decimal);
  return Math.floor(value * factor) / factor;
}
